module.exports = __webpack_public_path__ + "static/albedo-button-b5d7c02f9bfe2b2805a28445d798baa4.png";